import styled from 'styled-components'

export const SnapCarouselContainer = styled.div<{ $containerWidth: number; $isMobile: boolean; $isRTL: boolean }>`
  width: 100%;
  max-width: ${(props) => (props.$isMobile ? '100%' : `${props.$containerWidth}px`)};
  z-index: 10;
  margin: 0 auto;
  direction: ${(props) => (props.$isRTL ? 'rtl' : 'ltr')};
  overflow: hidden;
  min-height: fit-content;
`

export const SnapCarouselTrack = styled.div<{
  $perPage: number
  $gap: number
  $containerWidth: number
  $isMobile: boolean
  $isRTL: boolean
  $lastChildFullWidth: boolean
}>`
  display: flex;
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  -ms-overflow-style: none;
  gap: ${(props) => props.$gap}px;

  &::-webkit-scrollbar {
    display: none;
  }

  & > * {
    flex: 0 0 calc((100% - ${(props) => (props.$perPage - 1) * props.$gap}px) / ${(props) => props.$perPage});
    scroll-snap-align: start;
    scroll-snap-stop: always;
  }

  ${(props) =>
    props.$lastChildFullWidth &&
    props.$isMobile &&
    `
    padding-right: ${props.$containerWidth * (1 - 1 / props.$perPage)}px;
  `}
`

export const SnapCarouselSlide = styled.div<{
  $perPage: number
  $isMobile: boolean
  $isRTL: boolean
  $hasLastChildPadding?: boolean
  $isLastChild: boolean
  $lastChildFullWidth: boolean
  $paddingCarouselCard: number
}>`
  flex: 0 0 ${(props) => (props.$lastChildFullWidth && props.$isLastChild && props.$isMobile ? '100%' : `${100 / props.$perPage}%`)};
  scroll-snap-align: start;
  width: ${(props) => (props.$lastChildFullWidth && props.$isLastChild && props.$isMobile ? '100%' : `${100 / props.$perPage}%`)};
  box-sizing: border-box;
  padding: ${(props) => props.$paddingCarouselCard}px;

  ${(props) =>
    props.$hasLastChildPadding &&
    props.$isMobile &&
    `
    &:last-child {
      ${props.$isRTL ? `padding-left: 16px;` : `padding-right: 16px;`}
    }
  `}
`
